export const ApiSubDomainLookup = {
  tickets: 'tickets',
  account: 'account',
  dato: 'datocms',
} as const;
